import { render } from "./companyData.vue?vue&type=template&id=e9c56e00&scoped=true"
import script from "./companyData.vue?vue&type=script&lang=js"
export * from "./companyData.vue?vue&type=script&lang=js"

import "./companyData.vue?vue&type=style&index=0&id=e9c56e00&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c56e00"]])

export default __exports__